import {
  useNavigate as useReactRouterNavigate,
  NavigateOptions,
} from "react-router-dom";
import { useRoutes } from "@Libs/Router/hooks/useRoutes";
import {
  IGenerateRouteKey,
  IGenerateRouteParams,
  IGenerateRouteQueryParams,
} from "@Libs/Router/Contexts/RoutesContext";
import { IAppRoute } from "@App/types";
import { useLocation } from "./useLocation";

export interface UseNavigateOptions extends NavigateOptions {
  reload?: boolean;
  params?: IGenerateRouteParams;
  queryParams?: IGenerateRouteQueryParams;
  replace?: boolean;
  append?: boolean;
  back?: boolean;
  external?: boolean;
  /** Keep the locale segment of the URL on show; Rails serves the path under `(:locale)`. */
  withLocale?: boolean;
}

export const useNavigate = () => {
  const routerNavigate = useReactRouterNavigate();
  const { generateRoute } = useRoutes();
  const { pathname } = useLocation();

  const navigate = (
    to: IGenerateRouteKey,
    options?: UseNavigateOptions
  ): void => {
    if (options?.back) {
      routerNavigate(-1);
      return;
    }

    if (options?.external) {
      routerNavigate(to as string);
      return;
    }

    let url = generateRoute(
      options?.withLocale
        ? {
            fragments: to as IAppRoute | IAppRoute[],
            options: { withLocale: true },
          }
        : to,
      options?.params,
      options?.queryParams
    );

    if (options?.append) {
      url = pathname + url;
    }

    if (options?.reload) {
      routerNavigate(url, options);
      window.location.reload();
    } else {
      routerNavigate(url, options);
    }
  };

  return navigate;
};
